export default "__VITE_ASSET__uvmse6hA__"